import React from 'react'

export default function Delete() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none">
            <path d="M3 17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H11.165L11.521 19.577L11.541 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V11H7.75L7.934 10.995C8.76281 10.948 9.54221 10.5856 10.1123 9.98223C10.6824 9.37883 11.0001 8.58014 11 7.75V4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V11.232C19.979 11.042 20.494 10.969 21 11.012V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H10.871C10.2746 3.00026 9.70272 3.23729 9.281 3.659L3.658 9.28C3.23641 9.70212 2.99973 10.2744 3 10.871V17.75ZM7.75 9.5H5.561L9.5 5.561V7.75L9.494 7.894C9.45786 8.3317 9.25846 8.73981 8.93539 9.03732C8.61232 9.33483 8.18919 9.49998 7.75 9.5Z" fill="#F82117" />
            <path d="M15.4 21L14 19.6L16.1 17.5L14 15.4L15.4 14L17.5 16.1L19.6 14L21 15.4L18.925 17.5L21 19.6L19.6 21L17.5 18.925L15.4 21Z" fill="#F82117" />
        </svg>
    )
}
